import { AppHeaderBackButton, Box, Button } from '@ace-clublabs/shared-component-library';
import { ErrorComponent } from '@ace-clublabs/payments-component-library';
import LaptopGuy from '../assets/LaptopGuy.png';
import GuyOnTheFloor from '../assets/GuyOnTheFloor.png';
import { AppFlow } from '@lib/web-shared';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { ErrorType } from '../shared/types';
import CookieHelper from '../utils/cookieHelper';
import { ClubHelper, PolicyHelper } from '@ace-clublabs/payments-helper';
import { UtagHelper } from '../utils/utagHelper';

interface Props {
  errorTag?: string;
  errorType?: ErrorType;
}

export const SorryPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const [clubCodeFromState] = useGlobalState('clubCode');
  const [startPath] = useGlobalState('startPath');
  const [clubTag] = useGlobalState('clubTag');
  const [policyNumber] = useGlobalState('policyNumber');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [policyMetaData] = useGlobalState('policyMetaData');
  const [policyPaymentInfo] = useGlobalState('policyPaymentInfo');
  const [appFlow] = useGlobalState('appFlow');
  const { minimumDue, allowAutoPay } = policyPaymentInfo || {};

  const ispaymentError = props?.errorTag === UtagHelper.Errors.paymentError;
  const isSystemError = props?.errorType === ErrorType.SYSTEM_ERROR;

  const page = ispaymentError
    ? UtagHelper.getPages(appFlow).paymentErrorPage
    : isSystemError
    ? UtagHelper.getPages(appFlow).systemErrorPage
    : UtagHelper.getPages(appFlow).notFoundPage;

  const defaultError = ispaymentError
    ? UtagHelper.Errors.paymentError
    : isSystemError
    ? UtagHelper.Errors.systemError
    : UtagHelper.Errors.notFoundError;

  const error = appFlow === AppFlow.AUTOPAY && ispaymentError ? 'payment failed' : defaultError;

  useEffect(() => {
    const ins_min_due = minimumDue ? 'true' : 'false';
    const ins_autopaycampaign = allowAutoPay ? 'autopay required' : 'autopay not required';
    const ins_policy = policyMetaData?.prefix;

    const tags = {
      ...UtagHelper.loadCommonTags(appFlow),
      page,
      error,
      club: clubTag,
      state: policyMetaData?.state,
      ins_min_due: appFlow === AppFlow.AUTOPAY ? undefined : ins_min_due,
      ins_autopaycampaign: appFlow === AppFlow.AUTOPAY ? undefined : ins_autopaycampaign,
      ins_policy,
    };

    UtagHelper.tag(tags);
  }, []);

  const isGwError = props?.errorType === ErrorType.TEMPORARILY_UNAVAILABLE_ERROR;

  const title = isGwError
    ? 'We’re currently updating our online systems and cannot complete your request at this time'
    : isSystemError
    ? 'Our systems are temporarily unavailable'
    : 'The page you were looking for is no longer available';

  let buttonLabel = isGwError ? 'Find a branch nearby' : 'Return home';

  const displaySecondButton = !isSystemError;

  const onClickBackToStart = () => navigate(`${Pages.SubmitInsurance}${startPath}`);
  const onClickFindBranch = () => (window.location.href = 'https://www.ace.aaa.com/locations.html');
  const onClickReturnHome = () => (window.location.href = 'https://www.ace.aaa.com/');

  const clubCode =
    clubCodeFromState ||
    (policyNumber && PolicyHelper.getProductInfoFromPolicyNumber(policyNumber).clubCode) ||
    CookieHelper.getClubCodeFromZipcodeCookie();

  const clubPhoneNumber = ClubHelper.getClubPhoneNumber(clubCode);

  return (
    <Box className="inner-container">
      {!isMobileApp && !isGwError && (
        <AppHeaderBackButton id="back-to-start-button" onClick={onClickBackToStart} label="Back" />
      )}
      <ErrorComponent
        title={title}
        phoneNumber={clubPhoneNumber}
        imagePath={isGwError ? LaptopGuy : GuyOnTheFloor}
        overrideText={
          isGwError
            ? 'We apologize for the inconvenience. If you need immediate assistance, specialists at your AAA branch would be happy to help.'
            : undefined
        }
      ></ErrorComponent>
      {displaySecondButton && (
        <Button
          variant="contained"
          fullWidth
          id="action-button"
          className="margin8Top"
          onClick={isGwError ? onClickFindBranch : onClickReturnHome}
          label={buttonLabel}
        />
      )}
    </Box>
  );
};
